//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        options: {
            type: Array,
            default: []
        },
        value: null,
        startingOption: null,
        label: {
            type: String,
            default: null
        },
        multi: {
            type: Boolean,
            default: false
        },
        placeHolder: {
            type: String,
            default: 'Make a Choice...'
        },
        changeMethod: {
            type: String,
            default: ''
        }
    },
    data: function data() {
        return {
            showOptions: false,
            selectedOption: ''
        };
    },

    methods: {
        onSelect: function onSelect(option) {
            this.selectedOption = option;

            this.$emit('input', option.id);

            if (this.changeMethod) {
                Event.$emit(this.changeMethod, option.id);
            }
        }
    },
    mounted: function mounted() {
        var _this = this;

        Event.$on('update-select', function (option) {
            _this.selectedOption = option;
        });

        console.log('mounted() startingOption = ' + this.startingOption);
        if (this.startingOption) {
            console.log('set selectedOption = ' + this.startingOption);
            this.selectedOption = { label: this.startingOption, id: this.startingOption };
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/CMSJSelect.vue
// module id = 0TA8
// module chunks = 0 1